import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchDcUser } from '@/features/users/api'

import { dcUserParamsSchema } from '../-models/dc-user-params'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/$userId'
)({
  parseParams: (params) => parse(dcUserParamsSchema, params),
  loader: async ({
    abortController,
    params: { tenantKey, userId },
    context: { auth }
  }) => {
    return {
      authUser: auth.user,
      user: await fetchDcUser(
        {
          tenantKey,
          userId
        },
        abortController.signal
      )
    }
  },
  meta: ({ loaderData }) => [
    {
      title: loaderData.user.displayName
    }
  ]
})
